var calculatePartialPercents = function (total, components) {
    return Object.keys(components).map(function (keyName) { return ({
        label: keyName,
        value: components[keyName],
        percentValue: Math.round((components[keyName] / total) * 100) + "%",
    }); });
};
export default calculatePartialPercents;
